import './style.css';
import { Button, Input, Radio, Select, Spin } from 'antd';
import React, { useCallback } from 'react';
import Form, { Rule } from 'antd/lib/form';
import { FileExcelFilled } from '@ant-design/icons';
import { BankMasterFormPayloadType } from 'api/nach';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

type FormInputType = {
  name: string;
  label?: string;
  Component?: React.ReactNode;
  required?: boolean;
  rules?: any;
};
const FormInput = ({ name, label, Component, rules, required }: FormInputType) => {
  return (
    <div className="form-group col-xs-12 col-sm-6 col-md-6">
      <div className="input-box">
        <Form.Item label={label} required={required} rules={rules} name={name}>
          {Component}
        </Form.Item>
      </div>
    </div>
  );
};

type Props = {
  bankData: BankMasterFormPayloadType[];
  setBankData?: any;
  setFilter?: any;
};

function BankMasterForm({ bankData, setBankData }: Props) {
  // const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;

  const rules: Rule[] = [
    {
      type: 'string',
      required: true,
    },
  ];

  const handleSubmit = () => {
    const value = form.getFieldsValue();
    setBankData([...bankData, value]);
    form.resetFields();
  };
  const handleReset = () => {
    form.resetFields();
  };

  const s2ab = (s: any) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const handleDownload = useCallback(() => {
    const data = bankData;
    const fileName = 'BankMasterData.xlsx';

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

    saveAs(blob, fileName);
  }, [bankData]);

  return (
    <Spin
      // spinning={isLoading}
      spinning={false}
    >
      <Form<BankMasterFormPayloadType>
        layout="vertical"
        scrollToFirstError
        className="standard-forms"
        initialValues={{}}
        onFinish={handleSubmit}
        form={form}
      >
        <div className="row">
          <FormInput
            name="BankName"
            label="Bank Name"
            required
            rules={rules}
            Component={
              <Select placeholder="Select Bank" size="large">
                <Option value="SBI">SBI</Option>
                <Option value="HDFC">HDFC</Option>
                <Option value="ICICI">ICICI</Option>
              </Select>
            }
          />

          <FormInput rules={rules} required name="BankId" label="Bank Id: " Component={<Input />} />
        </div>
        <div className="row">
          <FormInput
            required
            name="NachType"
            label="NACH Type"
            rules={rules}
            Component={
              <Select placeholder="Nach Type" size="large">
                <Option value="P-NACH">P-NACH</Option>
                <Option value="E-NACH">E-NACH</Option>
                <Option value="Both">Both</Option>
              </Select>
            }
          />
          {/* </div>
        <div className="row"> */}
          <FormInput
            name="Status"
            label="Status"
            required
            rules={rules}
            Component={
              <Radio.Group size="large">
                <Radio style={{ fontSize: '16px', fontWeight: '600' }} value={'Active'}>
                  Active
                </Radio>

                <Radio style={{ fontSize: '16px', fontWeight: '600' }} value={'Inactive'}>
                  In Active
                </Radio>
              </Radio.Group>
            }
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '3px',
            marginTop: '20px',
            marginBottom: '20px',
          }}
        >
          <Button type="primary" htmlType="submit">
            Add
          </Button>
          <Button type="primary" onClick={handleReset}>
            Clear
          </Button>
          <Button
            type="link"
            icon={<FileExcelFilled />}
            style={{ float: 'right', fontSize: '30px', color: 'green' }}
            onClick={handleDownload}
          ></Button>
        </div>
      </Form>
    </Spin>
  );
}

export default BankMasterForm;
